import { useParams } from 'react-router-dom';
import { SymbolPageStep, useLeaseFundSymbolPage } from './hooks';
import { LoadingContainer, LoadingSize } from 'views/mutual/loading';
import { LeaseFundSymbolDetail, } from './symbolDetail';
import { LeaseFundSymbolApplyConfirm,  } from './symbolApplyConfirm';
import { LeaseFundSymbolApplyComplete, } from './symbolApplyComplete';
import { useEffect } from 'react';
import { NotFoundData } from 'views/mutual/notFoundData';
import { CompatibilityCheck } from '../../compatibilityCheck';
import { LeaseFundContractComplete } from 'views/pages/contractProcedure/leaseFund/contractComplete';
import { ContractProcedureStep, useContractProcedure } from 'views/pages/contractProcedure/leaseFund/hooks';
import { LeaseFundContractProcedure } from 'views/pages/contractProcedure/leaseFund';
import { ProductType } from 'constants/productType';

export const LeaseFundSymbol = () => {
  const { symbol } = useParams<{ symbol: string }>();

  const {
    symbolPageStep,
    symbolDetailInfo,
    applySymbolRes,
    confirmApplySymbolRes,
    formik,
    canApplySymbol,
    interest,
    amountRaw,
    totalAmountRaw,
    backDetailPage,
  } = useLeaseFundSymbolPage({ symbol: symbol! });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [symbolPageStep]);

  if (symbolDetailInfo.fetching) {
    return (
      <LoadingContainer isLoading={symbolDetailInfo.fetching} size={LoadingSize.Medium}>
        <div></div>
      </LoadingContainer>
    );
  } else {
    if (!symbolDetailInfo.data?.GetSymbolInfo) {
      return (
        <NotFoundData
          backPageType={{
            kind: 'previous',
          }}
        />
      );
    }

    switch (symbolPageStep) {
      case SymbolPageStep.Detail:
        return (
          <LeaseFundSymbolDetail
            symbolDetail={symbolDetailInfo.data?.GetSymbolInfo}
            formik={formik}
            interest={interest}
            totalAmountRaw={totalAmountRaw}
            canApplySymbol={canApplySymbol}
          />
        );
      case SymbolPageStep.CompatibilityCheck:
        return (
          <CompatibilityCheck
            assetType={ProductType.LeaseFund}
            completedNextPage={{
              label: '申込内容確認に進む',
              navigate: formik.handleSubmit,
            }}
          />
        );
      case SymbolPageStep.Confirm:
        return (
          <LeaseFundSymbolApplyConfirm
            symbolDetail={symbolDetailInfo.data?.GetSymbolInfo}
            formik={formik}
            interest={interest}
            amountRaw={amountRaw}
            totalAmountRaw={totalAmountRaw}
            backDetailPage={backDetailPage}
            applySymbolRes={confirmApplySymbolRes?.data?.ApplySymbol}
          />
        );
      case SymbolPageStep.Complete:
        return <LeaseFundSymbolApplyComplete />;
      case SymbolPageStep.ContractComplete:
        return (
          <LeaseFundContractProcedure
            applicationID={applySymbolRes?.data?.ApplySymbol?.ID!}
            defaultContractProcedureStep={ContractProcedureStep.Complete}
          />
        );
    }
  }
};